import { IconButton, Tooltip } from '@mui/material'
import * as React from 'react'
import { SvgIconComponent } from '@mui/icons-material'

type Props = {
  legend: string
  actionIcon?: SvgIconComponent
  actionLabel?: string
  onActionClick?: () => void
  children: React.ReactNode
  className?: string
}

export const WrapperFormContent = ({ legend, children, className, actionIcon: ActionIcon, actionLabel, onActionClick }: Props) => {
  const iconButton = ActionIcon ? (
    <IconButton
      size="small"
      onClick={onActionClick}
      sx={{
        backgroundColor: '#fef1f4',
        borderRadius: 2,
        marginLeft: 1,
      }}>
      <ActionIcon color="secondary" />
    </IconButton>
  ) : null

  const isSafari =
    navigator.userAgent.includes('Safari') &&
    !navigator.userAgent.includes('Chrome') &&
    !navigator.userAgent.includes('Chromium') &&
    !navigator.userAgent.includes('Edg') &&
    !navigator.userAgent.includes('OPR')
  if (!isSafari) {
    return (
      <fieldset className={`border border-gray-200 p-4 rounded-lg ${className}`}>
        <legend className="text-sm font-medium text-gray-700 mb-1 border border-gray-200 p-2 rounded-lg flex items-center">
          <span>{legend}</span>
          {actionLabel && iconButton ? (<Tooltip title={actionLabel}>{iconButton}</Tooltip>) : (iconButton)}
        </legend>
        {children}
      </fieldset>
    )
  }

  return (
    <fieldset className={`border border-gray-200 p-4 rounded-lg ${className}`}>
      <legend className="text-sm font-medium text-gray-700 mb-1 border border-gray-200 p-2 rounded-lg flex items-center">
        <span>{legend}</span>
      </legend>
      {iconButton && (<div className="mb-4 -mt-3">{actionLabel ? (<Tooltip title={actionLabel}>{iconButton}</Tooltip>) : (iconButton)}</div>)}
      {children}
    </fieldset>
  )
}
